import gql from 'graphql-tag'
import client from '@stores/apollo'

interface IProps {
  assignmentPlanId: string
  cities?: string[]
}
interface IPortfolioExport {
  data: {
    viewer: {
      company: {
        portfolio: {
          export: string
        }
      }
    }
  }
}

export default function exportCSV({ assignmentPlanId, cities }: IProps): Promise<IPortfolioExport> {
  const variables = {
    assignmentPlanId,
    cities,
  }
  return client.gql.query({ query, variables })
}

const query = gql`
  query portfolioQuery($assignmentPlanId: ID!, $cities: [String]) {
    viewer {
      company {
        portfolio(
          assignmentPlanId: $assignmentPlanId
          cities: $cities
          includeDepartment: true
          includeSpaceType: true
          includeUsageType: true
        ) {
          export
        }
      }
    }
  }
`
